import { render } from "./OurProcess.vue?vue&type=template&id=1ef8532b"
import script from "./OurProcess.vue?vue&type=script&lang=js"
export * from "./OurProcess.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\digitaldistribution.io-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__